import { useMutation } from '@tanstack/react-query';

import { ProfileServiceV1 } from '../../../services/axios/services/v1/profile-service';
import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';

type Props = {
  onSuccess: (
    response: Awaited<ReturnType<ProfileServiceV1['getRequestingUserProfile']>>,
  ) => void | Promise<void>;
  onError?: () => void | Promise<void>;
};

const useProfileQuery = (props: Props) =>
  useMutation({
    mutationFn: () =>
      SkyMapAxiosServiceFactory.instance.createProfileServiceV1().getRequestingUserProfile({}),
    retry: false,
    networkMode: 'always',
    onError: () => props?.onError?.(),
    onSuccess: (response) => props.onSuccess(response),
  });

export { useProfileQuery };
